import { render, staticRenderFns } from "./notice_merchant.vue?vue&type=template&id=57beac46&scoped=true"
import script from "./notice_merchant.vue?vue&type=script&lang=js"
export * from "./notice_merchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57beac46",
  null
  
)

export default component.exports